export const Images = {
  background: require("./background.png"),
};
